import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DynamicRenderSharedModule } from '../shared/shared.module';

import { ValidationMessagesComponent } from './validation-messages/validation-messages.component';

@NgModule({
  declarations: [ValidationMessagesComponent],
  exports: [ValidationMessagesComponent],
  imports: [CommonModule, DynamicRenderSharedModule]
})
export class ValidationsModule {}
